import React, {Fragment} from 'react';
import TextInput from '../../form/TextInput';
import ProductEditor from '../../editors/productEditor';
import Select from '../../form/Select';
import createForm from "./Form";
import classNames from 'classnames';
import SelectorGrid from "../../form/SelectorGrid/SelectorGrid";
import {
    BarcodeFormatter, ComponentFormatter,
    CurrencyFormatter, ProductColumn,
    ProductSelect,
    UnitFormatter
} from "../../../utils/formatters";
import {ifCompletedInput} from "../../../utils/other";
import {fileUpload, postData} from "../../../utils/request";
import Icon from "../../form/Icon";
import Modal from "../../layout/Modal";
import SelectorDocuments from "../../form/SelectorGrid/SelectorDocuments";
import DateInput from "../../form/DateTimeInput";
import {Tooltip} from "react-tippy";
import CheckBox from "../../form/CheckBox";
import TextArea from '../../form/TextArea';
import ComponentField from '../../form/ComponentField';
import DocumentInput from '../../form/DocumentInput';
import StoreOrderList from './../lists/BooklogStoreOrderList';
import StoreOrderEditor from "../storeorder/BooklogStoreOrderEditor";
import {connect} from "src/store";
import ModalEditor from "../ModalEditor";
import FragmentEditor from "../FragmentEditor";
import {get} from "../../../utils/dotutils";
import ProductPicker from "../OperationList/Elements/Inventory/ProductPicker";
import Confirm from "../../form/Confirm";

class BooklogStoreOrderForm extends React.Component {

    state = {
        updateItem: null,
        filtered: false,
        moditems: false,
    }

    addPickedItem = async (item) => {
        if (!parseInt(item.qty || 0)) return;
        try {
            await postData({
                parentcomponent: this.props.componentConfig.componentname,
                listfield: "items",
                parentid: this.props.values[this.props.componentConfig.idfield],
                action: "componentlist.addItemsToList",
                items: [item].map((item) => {
                    return {
                        data: {
                            product_id: item.id,
                            qty: parseInt(item.qty || 0),
                            OperationList_id: this.props.values[this.props.componentConfig.idfield]
                        }
                    };
                })
            });
        } catch (e) {
            console.error(e);
        }
        this.items.refresh();
    }

    render() {
        const sortable = true;
        const filterable = true;

        const isModifiedAble =
            this.props.stateType.Received(this.props.values.state)
            &&
            this.props.orderTypes.PURCHASE_ORDER(this.props.values.ordertype)
            &&
            get(this, "props.context.partner.partner_id") + "" === "" + get(this, "props.values.partner.partner_id");

        const modificationItems = JSON.parse(JSON.stringify(this.props.modificationItems || {}));
        let diffFilter = [];
        if (this.props.stateType.Revision(this.props.values.state, "<")) {
            diffFilter = [{fields: ["qty","pickedqty"], operator: "!<=>"}];
        } else if (this.props.stateType.Revision(this.props.values.state)) {
            diffFilter = [{fields: ["checkqty","pickedqty"], operator: "!<=>"}];
        } else if (this.props.stateType.Completed(this.props.values.state) || this.props.stateType.RevisionProcessed(this.props.values.state)) {
            diffFilter = [{
                filters: [
                    {fields: ["qty","pickedqty"], operator: "!<=>"},
                    {fields: ["pickedqty","checkqty"], operator: "!<=>"},
                    {fields: ["checkqty","confirmedqty"], operator: "!<=>"},
                ],
                operator: "OR"
            }];
        }
        if (!this.state.filtered) {
            diffFilter = [];
        }
        return (
            <Fragment>
                <form onSubmit={this.props.handleSubmit}>
                    <div className="row form-row">
                        <div className="col-md-1">
                            <TextInput
                                name={this.props.componentConfig.idfield}
                                value={this.props.values[this.props.componentConfig.idfield]}
                                label="Kód"
                                role="idfield"
                                {...this.props.getFieldProps(this.props.componentConfig.idfield)}
                            />
                        </div>
                        <div className="col-md-2">
                            <ComponentField
                                getFieldProps={this.props.getFieldProps}
                                componentConfig={this.props.componentConfig}
                                name="pid"
                                values={this.props.values}
                                setFieldValue={this.props.setFieldValue}
                            />
                        </div>
                        <div className="col-md-2">
                            <TextInput
                                name="orderid"
                                value={this.props.values.orderid}
                                label="Partner rendelés azonosító"
                                {...this.props.getFieldProps("orderid")}
                                disabled={true}
                            />
                        </div>
                        <div className="col-md-3">
                            <TextInput
                                name="notenum"
                                value={this.props.values.notenum}
                                label="Szállítólevél szám"
                                {...this.props.getFieldProps("notenum")}
                                disabled={true}
                            />
                        </div>
                        <div className="col-md-2">
                            <TextInput
                                name="booklog_id"
                                value={this.props.values.booklog_id}
                                label="Booklog azonosító"
                                {...this.props.getFieldProps("booklog_id")}
                                disabled={true}
                            />
                        </div>
                        <div className="col-md-2">
                            <DateInput
                                name="orderdate"
                                value={this.props.values.orderdate}
                                label="Rendelés dátuma"
                                {...this.props.getFieldProps("orderdate")}
                                disabled={true}
                            />
                        </div>
                        <div className="col-md-6">
                            {this.props.values.ordertype + '' === '0' ? <ComponentField
                                getFieldProps={this.props.getFieldProps}
                                componentConfig={this.props.componentConfig}
                                name="package_qty"
                                values={this.props.values}
                                setFieldValue={this.props.setFieldValue}
                                label="Csomagmennyiség"
                            /> : null}
                        </div>
                        <div className="col-md-6">
                            <Select
                                label="Státusz"
                                storeType="local"
                                optionname="BooklogStoreOrder_state"
                                value={this.props.values.state}
                                disabled={true}
                            />
                        </div>
                    </div>
                    <div className="row form-row">
                        <div className="col-sm-12">
                            <TextArea
                                name="comment"
                                value={this.props.values.comment}
                                label="Megjegyzés"
                                {...this.props.getFieldProps("comment")}
                                disabled={false}
                                saveChanges={this.props.setFieldValue}
                            />
                        </div>
                        {/*<div className="col-md-2">
                            <label className="control-label">&nbsp;</label>
                            {this.props.values.client_component && <ComponentConfig componentName={this.props.values.client_component}>
                                {(props) =>
                                <Link className="btn btn-default btn-block" target="_blank"
                                    to={"?" + urldecode(http_build_query({option: this.props.values.client_component, [props.componentConfig.idfield]: this.props.values.client_component_id}))}>
                                    Rendelés
                                </Link>}
                            </ComponentConfig>}
                        </div>*/}
                    </div>
                    <div className="row form-row">
                        <div className="col-md-12">
                            {this.props.values[this.props.componentConfig.idfield] && <Fragment>
                                {isModifiedAble && <ProductPicker
                                    props={{getFieldProps: this.props.getFieldProps}}
                                    addPickedItem={this.addPickedItem}
                                    async={true}
                                />}
                                <SelectorGrid
                                    {...this.props.getFieldProps("items")}
                                    ref={(e) => this.items = e}
                                    className={"p-small-table"}
                                    exports={[{as: "excel", label: "Excel", icon: "far fa-file-excel"}]}
                                    view={["id", "name", "qty", "product_id", "promisedqty", "picker.id"]}
                                    filter={[...(diffFilter),...(this.state.moditems ? [{field: "product_id", value: Object.keys(modificationItems), operator: "in"}] : [])]}
                                    paginatorRight={(props) =>
                                        <Fragment>
                                            {Object.keys(modificationItems).length ? <Tooltip title={!this.state.moditems ? "Csak a módosításokat mutatása" : "Mindent mutat"}>
                                                <CheckBox
                                                    {...props}
                                                    onIcon={{lib: "fas", name: "pencil-alt"}}
                                                    offIcon={{lib: "fas", name: "pencil-alt"}}
                                                    value={this.state.moditems}
                                                    label={false}
                                                    saveChanges={(field, value) => {
                                                        this.setState({moditems: !!value});
                                                    }}
                                                />
                                            </Tooltip> : null}
                                            <Tooltip title={!this.state.filtered ? "Csak az eltérések mutatása" : "Mindent mutat"}>
                                                <CheckBox
                                                    {...props}
                                                    onIcon={{lib: "fa", name: "box"}}
                                                    offIcon={{lib: "fa", name: "box-open"}}
                                                    value={this.state.filtered}
                                                    label={false}
                                                    saveChanges={(field, value) => {
                                                        this.setState({filtered: !!value});
                                                    }}
                                                />
                                            </Tooltip>
                                        </Fragment>}
                                    onItemUpdate={async (item, oldItem, field, rowIndex, {listfieldComponentConfig}) => {
                                        const updateItem = {[listfieldComponentConfig.idfield]: item[listfieldComponentConfig.idfield]};
                                        Object.keys(listfieldComponentConfig.fielddefs).map((key) => {
                                            if (item[key] !== oldItem[key]) {
                                                updateItem[key] = item[key];
                                            }
                                        });
                                        let actionparams = {
                                            parentcomponent: this.props.componentConfig.componentname,
                                            listfield: "items",
                                            parentid: this.props.values[this.props.componentConfig.idfield],
                                            action: "componentlist.updateItems",
                                            items: [updateItem]
                                        };
                                        await postData(actionparams);
                                        return true;
                                    }}
                                    columns={{
                                        ...(isModifiedAble ? {
                                            "actions": {
                                                header: ' ',
                                                width: 'cell-button',
                                                renderer: (value, rowData) => {
                                                    return <Confirm
                                                        header="Törlés"
                                                        body="Biztos törlöd ezt a tételt?"
                                                        className="btn btn-danger btn-xs"
                                                        color="danger"
                                                        acceptButton="Törlés"
                                                        icon={{lib: "fa", name: "trash"}}
                                                        onAccept={async (e) => {
                                                            e && e.preventDefault();
                                                            await postData({
                                                                parentcomponent: this.props.componentConfig.componentname,
                                                                listfield: "items",
                                                                parentid: this.props.values[this.props.componentConfig.idfield],
                                                                action: "componentlist.removeItemsFromList",
                                                                items: [rowData]
                                                            });
                                                            this.items.refresh();
                                                        }}
                                                    />;
                                                }
                                            }
                                        } : {}),
                                        "name": {
                                            header: 'Megnevezés',
                                            width: 8,
                                            sortable,
                                            filterable
                                        },
                                        "barcode": {
                                            header: 'Vonalkód',
                                            width: 1,
                                            sortable,
                                            filterable
                                        },
                                        "listprice": {
                                            header: 'Ár',
                                            width: 1,
                                            sortable,
                                            filterable,
                                            renderer: CurrencyFormatter,
                                            className: "currency"
                                        },
                                        "qty": {
                                            header: 'Darabszám',
                                            width: 1,
                                            sortable,
                                            filterable,
                                            renderer: (value, row) => UnitFormatter(value || 0, row.unit),
                                            className: "unit",
                                            editor:
                                                isModifiedAble ? (parent) =>
                                                    (props, value) =>
                                                        <TextInput type="number" name="qty" label={false} focus value={value}
                                                                   onKeyDown={(e, field, value) => {ifCompletedInput(e) && parent.onEditorValueChange(props, value);}}
                                                                   onBlur={(e, field, value) => parent.onEditorValueChange(props, value)}/> : null
                                        },
                                        ...(this.props.orderTypes.SALES_ORDER(this.props.values.ordertype) && this.props.stateType.Revision(this.props.values.state, "<") ? {
                                            "promisedqty": {
                                                header: 'Visszaigazolva',
                                                width: 1,
                                                sortable,
                                                filterable,
                                                renderer: (value, row) => UnitFormatter(value || 0, row.unit),
                                                className: "unit"
                                            }
                                        } : {}),
                                        ...(this.props.stateType.Received(this.props.values.state, ">") ? {
                                            "pickedqty": {
                                                header: this.props.orderTypes.PURCHASE_ORDER(this.props.values.ordertype) ? 'Bevételezve' : 'Kiszedve',
                                                width: 1,
                                                sortable,
                                                filterable,
                                                renderer: (value, row) => UnitFormatter(value || 0, row.unit),
                                                className: "unit",
                                            },
                                        } : {}),
                                        ...(this.props.stateType.Revision(this.props.values.state, ">=") ? {
                                            "checkqty": {
                                                header: "Visszaigazolva",
                                                width: 1,
                                                sortable,
                                                filterable,
                                                aggregation: (value, row) => UnitFormatter(value, row.unit),
                                                renderer: (value, row) => UnitFormatter(value, row.unit),
                                                className: "unit",
                                            },
                                            "confirmedqty": {
                                                header: "Ellenörzés",
                                                width: 1,
                                                sortable,
                                                filterable,
                                                aggregation: (value, row) => UnitFormatter(value, row.unit),
                                                renderer: (value, row) => UnitFormatter(value, row.unit),
                                                className: "unit",
                                                editor:
                                                    (parent) =>
                                                        (props, value) =>
                                                            this.props.stateType.Revision(this.props.values.state) && <TextInput type="number" name="confirmedqty" label={false} focus value={value}
                                                                                                                                 onKeyDown={(e, field, value) => {ifCompletedInput(e) && parent.onEditorValueChange(props, value);}}
                                                                                                                                 onBlur={(e, field, value) => parent.onEditorValueChange(props, value)}/>
                                            },
                                        } : (this.props.stateType.Modification(this.props.values.state) ? {
                                            "pickedqty": {
                                                header: this.props.values.ordertype + '' === '1' ? 'Bevételezve' : 'Kiszedve',
                                                width: 1,
                                                sortable,
                                                filterable,
                                                renderer: (value, row, rowIndex, props, parent) => {
                                                    if (!props.isAggregation && modificationItems[row.product_id] !== undefined) {
                                                        return <span className="unit">
                                                            <Tooltip title={"Eredetileg " + (this.props.values.ordertype + '' === '1' ? 'bevételezve' : 'kiszedve')}><i>({UnitFormatter(value || 0, row.unit).props.children}) </i></Tooltip>
                                                            {UnitFormatter(modificationItems[row.product_id], row.unit).props.children}
                                                        </span>;
                                                    } else {
                                                        return UnitFormatter(value || 0, row.unit)
                                                    }
                                                },
                                                className: "unit",
                                                editor:
                                                    (parent) =>
                                                        (props, value) =>
                                                            <TextInput
                                                                type="number"
                                                                name="pickedqty"
                                                                label={false}
                                                                focus
                                                                value={modificationItems[props.rowData.product_id] || value}
                                                                onKeyDown={(e, field, value) => {
                                                                    if (ifCompletedInput(e)) {
                                                                        if (value !== '') {
                                                                            if (value != props.rowData.pickedqty) {
                                                                                modificationItems[props.rowData.product_id] = value;
                                                                            } else {
                                                                                delete modificationItems[props.rowData.product_id];
                                                                            }
                                                                            this.props.setModificationItems && this.props.setModificationItems(modificationItems);
                                                                        }
                                                                    }
                                                                }}
                                                                onBlur={(e, field, value) => {
                                                                    if (value !== '') {
                                                                        if (value != props.rowData.pickedqty) {
                                                                            modificationItems[props.rowData.product_id] = value;
                                                                        } else {
                                                                            delete modificationItems[props.rowData.product_id];
                                                                        }
                                                                        this.props.setModificationItems && this.props.setModificationItems(modificationItems);
                                                                    }
                                                                }}
                                                            />
                                            },
                                        } : {})),
                                        ...(this.props.user.hasPermission("view_picker") || this.props.user.hasPermission("set_picker") ? {"picker.name": {
                                                header: 'Szedő',
                                                width: 1,
                                                sortable,
                                                filterable,
                                                renderer: (value, row, rowIndex, props, parent) => this.props.user.hasPermission("set_picker") ? <Select
                                                    component="user"
                                                    label={false}
                                                    isClearable={true}
                                                    name="picker"
                                                    storeType="local"
                                                    filter={{field: "partner", value: this.props.context.partner.partner_id}}
                                                    labelKey="name"
                                                    value={get(row, "picker.id")}
                                                    objectValue={false}
                                                    saveChanges={(field, value) => parent.onEditorValueChange({...props, fieldName: "picker"}, value)}
                                                /> : value
                                            }
                                        } : {})
                                    }}
                                    onSort={(field, direction) => {
                                        if (this.props.stateType.Modification(this.props.values.state)) {
                                            if (field === "pickedqty" && !!Object.keys(modificationItems).length) {
                                                return {
                                                    expression: "FIELD({{product_id}}, " + Object.keys(modificationItems).sort((a, b) => modificationItems[a].pickedqty - modificationItems[b].pickedqty).join(", ") + ")",
                                                    direction
                                                };
                                            }
                                        }
                                    }}
                                    rowClassName={(rowData) => {
                                        const pickedqty = this.props.values.ordertype + '' === '1' ? parseInt(rowData.pickedqty || 0) : parseInt(rowData.promisedqty || 0);
                                        const qty = parseInt(rowData.qty || 0);
                                        const classes = {};
                                        if (pickedqty > qty) {
                                            classes["p-highlight danger"] = true;
                                        } else if(qty > pickedqty) {
                                            classes["p-highlight"] = true;
                                        }
                                        return classes;
                                    }}
                                    aggregations={{
                                        fields: {
                                            "qty": {
                                                field: "qty", type: "SUM"
                                            },
                                            "promisedqty": {
                                                field: "promisedqty", type: "SUM"
                                            },
                                            "pickedqty": {
                                                field: "pickedqty", type: "SUM"
                                            },
                                            "checkqty": {
                                                field: "checkqty", type: "SUM"
                                            },
                                            "confirmedqty": {
                                                field: "confirmedqty", type: "SUM"
                                            },
                                        }
                                    }}
                                    listfield="items"
                                    data={this.props.values}
                                    orderBy={{field: "name", direction: "ASC"}}
                                    componentConfig={this.props.componentConfig}
                                />
                            </Fragment>}
                        </div>
                    </div>
                    <div className="row form-row">
                        <div className="col-md-12">
                            {
                                this.props.componentConfig.fielddefs.documents
                                && this.props.componentConfig.fielddefs.documents.type === "componentlist"
                                &&
                                <Fragment>
                                    <label className="control-label">Dokumentumok</label>
                                    <SelectorGrid
                                        {...this.props.getFieldProps("documents")}
                                        disabled={false}
                                        componentConfig={this.props.componentConfig}
                                        view={["filename", "path", "type"]}
                                        type={SelectorDocuments}
                                        onAddRows={async (acceptedFiles, type) => {
                                            if (type + "" === "1") {
                                                return await fileUpload({
                                                    action: this.props.componentConfig.componentname + ".addDocument",
                                                    id: this.props.values[this.props.componentConfig.idfield],
                                                    Document: acceptedFiles[0]
                                                });
                                            } else {
                                                return await fileUpload({
                                                    action: this.props.componentConfig.componentname + ".addLabel",
                                                    id: this.props.values[this.props.componentConfig.idfield],
                                                    Document: acceptedFiles[0]
                                                });
                                            }
                                        }}
                                        pageSize={0}
                                        name="documents"
                                        data={this.props.values}
                                        orderBy={{field: "filename", direction: "ASC"}}
                                    />
                                </Fragment>
                            }
                        </div>
                    </div>
                    {this.props.stateType.Modification(this.props.values.state, ">=") && <div className="row form-row">
                        <div className="col-md-12">
                            <div className="form-group">
                                <label className="control-label">Helyesbítő rendelések</label>
                                <StoreOrderEditor
                                    editorContext="SubStoreOrders"
                                    parent={this.props}
                                    editor={ModalEditor}
                                    list={FragmentEditor}
                                    listFilter={[
                                        {field: "orderid", value: this.props.values[this.props.componentConfig.idfield]},
                                        {field: "partner", value: this.props.context.partner.partner_id},
                                    ]}
                                />
                            </div>
                        </div>
                    </div>}
                    {this.props.splitAble && <div className="row form-row">
                        <div className="col-md-12">
                            <div className="form-group">
                                <label className="control-label">Rész rendelések</label>
                                <StoreOrderEditor
                                    editorContext="SubStoreOrders"
                                    parent={this.props}
                                    editor={ModalEditor}
                                    list={FragmentEditor}
                                    listFilter={[
                                        {field: "orderid", value: this.props.values[this.props.componentConfig.idfield]},
                                        {field: "partner", value: this.props.context.partner.partner_id},
                                    ]}
                                />
                            </div>
                        </div>
                    </div>}
                </form>
            </Fragment>
        );
    }
}

export default connect((state) => {
    return {
        context: state.app.context
    }
})(createForm(BooklogStoreOrderForm));
